import { Button, Form, Input, Select, message } from "antd";
import { useState } from "react";
import http from "../../../../services/http";

const rulesValidation = {
  matricula: [{ required: true, message: "Digite a matrícula!" }],
  metodo: [{ required: true, message: "Selecione o método!" }],
};

const metodoOptions = [
  {
    value: 1,
    label: "E-mail",
  },
  {
    value: 2,
    label: "Celular (SMS)",
  },
];

const FormSolicitacao = ({ onSuccess }) => {
  const [loading, setLoading] = useState(false);

  // SOLICITAR RECUPERAÇÃO DE SENHA
  const solicitarRecuperacao = async (formulario) => {
    setLoading(true);
    const api = await http("post", "v1/autenticacao/solicitar_recuperacao", formulario);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      message.success(response?.message);
      onSuccess(formulario.matricula);
    } else {
      message.error(api?.response?.message);
    }
    setLoading(false);
  };

  return (
    <Form layout="vertical" onFinish={solicitarRecuperacao} autoComplete="off">
      <Form.Item name="matricula" label="Matrícula" rules={rulesValidation.matricula}>
        <Input size="large" disabled={loading} placeholder="Informe a matrícula" />
      </Form.Item>

      <Form.Item name="metodo" label="Método" rules={rulesValidation.metodo}>
        <Select size="large" disabled={loading} placeholder="Selecione o método" options={metodoOptions} />
      </Form.Item>

      <Form.Item className="FormItem">
        <Button block size="large" loading={loading} type="primary" htmlType="submit">
          Enviar
        </Button>
      </Form.Item>
    </Form>
  );
};

export { FormSolicitacao };
